import localSave from '@utils/local-save'

const STORAGE_KEY = 'libraryPreferences'

function readPrefs() {
    const stored = localSave.get(STORAGE_KEY)
    return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {}
}

export default {
    getSort(section) {
        const prefs = readPrefs()
        return prefs[`sort.${section}`] || null
    },
    setSort(section, key) {
        const prefs = readPrefs()
        prefs[`sort.${section}`] = key
        localSave.save(STORAGE_KEY, prefs)
    },
}
